// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"lucide lucide-arrow-big-up-dash-icon lucide-arrow-big-up-dash\"><path d=\"M9 19h6\"/><path d=\"M9 15v-3H5l7-7 7 7h-4v3H9z\"/></svg>";
// Exports
module.exports = code;